import MosScreen from './MosScreen'
import MosInfoProvider from './Widgets/common/provider/MosInfoProvider'

const MainMos = () => {
  return (
    <MosInfoProvider>
      <MosScreen />
    </MosInfoProvider>
  )
}

export default MainMos
